import { useAdminSessionInit } from '@hooks/useAdminSessionInit';
import { type FunctionComponent, type PropsWithChildren } from 'react';

const AdminAppInitializer: FunctionComponent<PropsWithChildren> = ({ children }) => {
  useAdminSessionInit();
  return <>{children}</>;
};

export { AdminAppInitializer };
